import { useMutation } from 'react-query';
import { useService } from 'shared/providers';
import { SendCustomerNotificationProps } from 'shared/services';

export function useSendCustomerDeleteNotification() {
  const { customerService } = useService();
  const mutation = useMutation<void, Error, SendCustomerNotificationProps>(request =>
    customerService.sendCustomerDeleteNotification(request)
  );

  return mutation;
}
